import React from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import Icon from 'icons';
import global from 'global';
import { useSelector } from 'store/hooks';
import styles from './result.module.scss';
import Loading from 'components/loading';
import { TypewriterText } from 'components/typewriter-text';
import Pdf from 'components/pdf';
import { toast } from 'react-toastify';

const Result = () => {
  const [shapLoading, setShapLoading] = React.useState(false);
  const contextApplication = useSelector((state) => state.application);
  const contextCities = useSelector((state) => state.cities);
  const navigate = useNavigate();

  const [selectedRecommendation, setSelectedRecommendation] =
    React.useState<global.recommendations_log | null>(null);

  React.useEffect(() => {
    if (contextApplication.data?.is_approved === null) navigate('/');
  }, [contextApplication, navigate]);

  React.useEffect(() => {
    if (!contextApplication.pending && !contextApplication.data) {
      toast.error('Заявка с такими данными не найдена');
      navigate('/');
    }
  }, [contextApplication]);

  React.useEffect(() => {
    const rec = contextApplication.data?.recommendations_log;
    if (!rec) return;
    const find = rec.find((e) => e.is_chosen);
    if (!find) return;
    setSelectedRecommendation(find);
  }, [contextApplication]);

  return (
    <div className={styles.result}>
      <div className={styles.content}>
        <div className={styles.pdf}>
          <Pdf
            contextApplication={contextApplication}
            selectedRecommendation={selectedRecommendation}
            contextCities={contextCities}
          />
        </div>
        {contextApplication.data?.scoring_log?.shap_link && (
          <div className={styles.shap_value}>
            {shapLoading && (
              <div className={styles.loading_shap}>
                <Loading />
              </div>
            )}
            <div className={styles.shap_value_title}>Значения Шэпли для принятия решений</div>
            {contextApplication.data?.scoring_log && (
              <>
                <iframe
                  title="shap_link"
                  src={contextApplication.data?.scoring_log?.shap_link}
                  style={{ width: '100%' }}
                  onLoad={() => setShapLoading(false)}
                ></iframe>
              </>
            )}
            <div className={styles.gpt_text}>
              {contextApplication?.data?.gpt_text && (
                <TypewriterText
                  text={contextApplication?.data?.gpt_text.ru}
                  id={contextApplication?.data?.id}
                  speed={30}
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div className={styles.resultBoxGroup}>
        {contextApplication?.data?.is_approved &&
          contextApplication.data.selected_recommendation &&
          selectedRecommendation && (
            <div className={styles.container_rec}>
              <div className={styles.container_rec__title}>Выбранная рекомендация</div>
              <div className={styles.container_rec__item}>
                <p>Сумма</p>
                <p>{selectedRecommendation.amount} TJS</p>
              </div>
              <div className={styles.container_rec__item}>
                <p>Срок</p>
                <p>{selectedRecommendation.duration} мес.</p>
              </div>
              <div className={styles.container_rec__item}>
                <p>Вероятность выплаты</p>
                <p>{(selectedRecommendation.prob * 100).toFixed(1)} %</p>
              </div>
            </div>
          )}
        {contextApplication.data && (
          <div className={styles.resultBox}>
            <div className={styles.resultBox_title}>Статус заявки</div>
            <Icon
              size={120}
              name={contextApplication.data.scoring_log.is_approved ? 'tickCircle' : 'closeFilled'}
              className={classNames(
                contextApplication.data.scoring_log.is_approved
                  ? styles.resultBox_icon_success
                  : styles.resultBox_icon_error,
              )}
            />

            {selectedRecommendation && (
              <p className={styles.selected_rec_text}>Одобрено по рекомендации</p>
            )}
            <div className={styles.resultBox_resultText}>
              <p>{contextApplication.data.scoring_log.is_approved ? 'Одобрено' : 'Отказано'}</p>
              <p>
                {selectedRecommendation
                  ? (selectedRecommendation.prob * 100).toFixed(1)
                  : contextApplication.data.scoring_log.prediction * 100}
                %
              </p>
            </div>
            <div className={styles.resultBox_resultText}>
              <p>Порог</p>
              <p>{contextApplication.data.scoring_log.threshold * 100}%</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Result, () => true);
